import { render, staticRenderFns } from "./InsuranceAncillary.vue?vue&type=template&id=f754f012&"
import script from "./InsuranceAncillary.vue?vue&type=script&lang=js&"
export * from "./InsuranceAncillary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports